// extracted by mini-css-extract-plugin
export default {"wrapper":"TwoFactor_wrapper__NZE2C","card":"TwoFactor_card__cVnvv","companyName":"TwoFactor_companyName__sNx0d","title":"TwoFactor_title__Z46Q7","desc":"TwoFactor_desc__vdir0"};